import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["link", "onClick", "children"];
import styled, { css } from 'styled-components';
import MenuItem from './MenuItem';
import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { getTypographyStyles } from '../../../nav-ui-components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMenuItem = styled(MenuItem)(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["list-style-type:none !important;color:", " !important;", " word-wrap:break-word;width:100%;padding:", " ", " !important;display:block;&:hover{background-color:", ";}"], theme.color['text-primary-default'], getTypographyStyles(theme, 'detail-200'), theme.space['200'], theme.space['600'], theme.color['fill-secondary-subtle']);
});
const StyledLabel = styled.div.withConfig({
  displayName: "MenuPickerSubmenuItem__StyledLabel",
  componentId: "sc-16lkwfc-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["white-space:nowrap;font-weight:500 !important;display:inline-block;font-size:14px !important;color:", " !important;span{font-size:0.875rem !important;font-weight:400 !important;display:inline-block;margin-left:", " !important;}"], theme.color['text-primary-default'], theme.space['100']);
});
export const MenuPickerSubmenuItem = memoWithDisplayName('MenuPickerSubmenuItem', _ref => {
  let {
      link,
      onClick,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledMenuItem, Object.assign({
    href: link,
    onClick: onClick
  }, rest, {
    children: /*#__PURE__*/_jsx(StyledLabel, {
      children: children
    })
  }));
});